import styled from "styled-components";

export const HomeContainer = styled.section`
  width: 100%;
  height: 85vh;

  display: flex;
  flex-direction: row;
  align-items: center;

  justify-content: space-between;

  .section{
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (min-width: 850px){
        padding-left: 5rem;
        justify-content: space-around;
    }

    @media (min-width: 1000px){
        padding-left: 10rem;
    }
    height: 25rem;
  }
`;

export const StyledHomeContent = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;

  h3,
  h1,
  p {
    padding-left: 2rem;
  }

  h3 {
    color: var(--dark--especial-text);
    font-size: 1.125rem;
    font-weight: 450;
  }

  h1 {
    font-size: 3.875rem;
    color: var(--dark--especial-text);
    line-height: 3.5rem;
    margin-top: 0.625rem;
    font-weight: 400;
  }

  p {
    color: var(--dark--green--50);
    font-size: 1.15rem;
    font-weight: 450;
  }
`;
export const StyledSecondaryContent = styled.section`
  height: 35%;
  display: flex;
  flex-direction: column;
  justify-content: end;

  h3 {
    color: var(--dark--blue--700);
    font-size: 0.775rem;
    font-weight: 450;
    padding-left: 2rem;
  }

  p {
    color: var(--dark--links);
    font-size: 0.875rem;
    font-weight: 500;
    padding-left: 2rem;

    span{
        color: var(--dark--blue--500);
    }

    span + span {
      color: var(--dark--green--50);
    }

    span + span + span {
      color: var(--dark--red--700);
    }
  }

  
`;

export const StyledPhotoSection = styled.section`

  width: 40%;
    img{
        width: 20rem;
        border-radius: 50%;
        border: 4px solid var(--dark--green--50);
    }
`
